import { useParams } from 'react-router-dom';

import TaskDetail from '~/components/maud/tasks/TaskDetail';

const TaskDetailPage = () => {
  const { uuid } = useParams<{ uuid: string }>();

  return <TaskDetail taskId={uuid} />;
};

export default TaskDetailPage;
